import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV = [
  { to: "/", label: "Overview" },
  { to: "/sponsor", label: "Sponsor View" },
  { to: "/requests", label: "Build Requests" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/diagnostics", label: "Diagnostics" },
];

export default function Layout({ children }) {
  const loc = useLocation();
  const onPublicReceipt = loc.pathname.startsWith("/r/");

  return (
    <div className="App relative bc-grain" data-testid="app-shell">
      <header className="border-b border-[hsl(var(--border))] bg-[hsl(var(--bc-paper))]/80 backdrop-blur sticky top-0 z-30">
        <div className="bc-shell flex items-center justify-between h-[68px]">
          <Link to="/" className="flex items-baseline gap-3" data-testid="brand-link">
            <span className="font-display text-[22px] font-medium tracking-tight text-[hsl(var(--bc-ink))]">
              BuildCierge
            </span>
            <span className="eyebrow hidden sm:inline" data-testid="brand-subtitle">Governed software delivery</span>
            <span className="eyebrow hidden lg:inline text-[hsl(var(--bc-muted))]" data-testid="brand-demo-label">· A KATLAS Cierge demo</span>
          </Link>
          {!onPublicReceipt && (
            <nav className="hidden md:flex items-center gap-7" data-testid="primary-nav">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  className="bc-nav-link"
                  data-active={loc.pathname === n.to || (n.to !== "/" && loc.pathname.startsWith(n.to))}
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          )}
          <div className="flex items-center gap-3">
            <span className="signal-dot" aria-hidden />
            <span className="eyebrow eyebrow-signal hidden sm:inline">CAR · Custody · Authority · Receipts</span>
          </div>
        </div>
      </header>

      <main className="bc-shell py-12">{children}</main>

      <footer className="border-t border-[hsl(var(--border))] mt-24">
        <div className="bc-shell py-10 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="font-display text-[20px] tracking-tight">BuildCierge</div>
            <p className="text-sm text-[hsl(var(--bc-muted))] max-w-xl mt-2">
              AI may suggest. Technical authority decides. KATLAS signs the governed action.
              Synthetic demo data. No real client names, repositories, secrets or production logs.
            </p>
          </div>
          <div className="flex items-center gap-6 text-xs text-[hsl(var(--bc-muted))]">
            <Link to="/diagnostics" className="bc-nav-link" data-testid="footer-diagnostics-link">KATLAS diagnostics</Link>
            <span className="font-mono">v0.1 · Stage&nbsp;1</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
